import { guidePropertiesSelector } from '../selectors/properties';
import { guideChangeSelectedIndexThunkAction } from './changeSelectedIndex';
import { GUIDE_LIST_ITEM_KIND } from '../constants';
import { guidePlaySelectedChannelThunkAction } from './playSelectedChannel';
import { playerSetInfoBannerThunkAction } from '../../player/actions/setInfoBanner';

const isChannel = ({ kind }) => kind === GUIDE_LIST_ITEM_KIND.CHANNEL;

export const guideSelectPreviousIndexThunkAction = ({
  autoPlay = false,
  updateInfo = false,
} = {}) => async (dispatch, getState) => {
  const state = getState();

  const { selectedIndex, list } = guidePropertiesSelector(state);
  const itemCount = list.length - 1;
  const reverseSelectedIndex = itemCount - selectedIndex;
  const reverseList = list.slice().reverse();
  let newIndex = reverseList.findIndex(
    ({ kind }, index) => index > reverseSelectedIndex && isChannel({ kind }),
  );
  if (newIndex === -1) {
    newIndex = reverseList.findIndex(isChannel); // return to first channel
  }

  // get actual index
  newIndex = itemCount - newIndex;

  await dispatch(guideChangeSelectedIndexThunkAction({ newIndex }));

  if (autoPlay) {
    await dispatch(guidePlaySelectedChannelThunkAction());
  } else if (updateInfo) {
    const { id } = list.find(({ index }) => index === newIndex);
    await dispatch(playerSetInfoBannerThunkAction({ id }));
  }
};
